import React, { useState, useEffect } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { View, Text, Image, StyleSheet, Pressable, Linking } from 'react-native'
import { TextInput } from 'react-native-web'
import Header from '@components/Header'
import { i18n } from '@lib/i18n'
import runAsync from '@lib/utils/runAsync'
import StepDescription from '@components/StepDescription'
import Button from '@components/Button'
import Container from '@components/Container'
import Show from '@components/Show'
import { colors } from '@lib/colors'
import MainLayout from '@layouts/MainLayout'

const COPY = i18n.en.WORK_ORDERS.CREATE.EMAIL_VERIFICATION

export default function ({ onNext }: DefaultStepProps) {
  const [email, setEmail] = useState<string>('')

  function isValidEmail () {
    return !!email?.match(/^\S+@\S+\.\S+$/)
  }

  async function addEmailToStorage () {
    if (!email) return
    await AsyncStorage.setItem('email', email)
    onNext(email)
  }

  useEffect(() => {
    let mounted = true

    runAsync(async () => {
      const email = await AsyncStorage.getItem('email')
      if (email && mounted) setEmail(email)
    })

    return () => { mounted = false }
  }, [])

  return (
    <MainLayout hideBackButton>
      <Container>
        <View style={ styles.container }>
          <Image source={ require('@assets/Logo.png') } style={ styles.brand }/>
          <Header>{ COPY.HEADER }</Header>
          <StepDescription>{ COPY.DESCRIPTION }</StepDescription>

          <View style={{ width: '100%' }}>
            <TextInput
              placeholder={ COPY.EMAIL_INPUT_PLACEHOLDER }
              placeholderTextColor={ colors.gray[500]}
              style={ styles.input }
              value={ email }
              autoCapitalize={ 'none' }
              autoCompleteType={ 'email' }
              onChangeText={ setEmail }
              keyboardType={ 'email-address' }
            />

            <Show
              when={ isValidEmail() }
              fallback={
                <Button label={ COPY.NEXT_STEP } disabled />
              }
            >
              <Button
                onPress={ addEmailToStorage }
                label={ COPY.NEXT_STEP }
                buttonStyles={ styles.button }
              />
            </Show>

            <Pressable onPress={ () => Linking.openURL('https://www.spackle.co/terms') }>
              <Text style={ styles.disclaimerText }>{ COPY.DISCLAIMER }</Text>
            </Pressable>
          </View>
        </View>
      </Container>
    </MainLayout>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
  },
  brand: {
    height: 90,
    width: 90,
  },
  input: {
    backgroundColor: colors.gray[100],
    borderRadius: 6,
    marginBottom: 20,
    marginTop: 20,
    padding: 15,
  },
  button: {
    backgroundColor: colors.blue[300],
  },
  loginButton: {
    marginTop: 30,
    backgroundColor: colors.white,
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.05,
    shadowRadius: 4,
  },
  loginButtonText: {
    color: colors.gray[500],
  },
  disclaimerText: {
    color: colors.blue[600],
    fontSize: 12,
    marginTop: 20,
    textAlign: 'center',
  },
})
